import React, { useState } from 'react';
import SideMenu from '../SideMenu';
import { translate } from '../../Services/translation';
import FilterMenu from '../Filter/FilterMenu';
import Icon from '../Icon';
import { useDispatch, useSelector } from 'react-redux';
import { clearFilters } from '../../Actions/FacetedSearch.action';

const MobileFilterMenu = () => {
  const [open, setOpen] = useState(false);
  const { products } = useSelector((state) => state.productListing);
  const dispatch = useDispatch();

  const FilterMenuFooter = () => {
    return (
      <>
        <button
          className="filter-menu__button filter-menu__button--clear"
          onClick={() => dispatch(clearFilters())}
        >
          {translate('general.clear')}
        </button>
        <button
          className="filter-menu__button filter-menu__button--apply"
          onClick={() => setOpen(false)}
        >
          {translate('category.show-products').replace('{0}', products.length)}
        </button>
      </>
    );
  };

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="filter-menu__button--open"
      >
        <Icon name="Filter" size={24} className="filter-menu__button-icon" />
        {translate('general.filter')}
      </button>
      <SideMenu
        id="filter-menu"
        open={open}
        title={translate('general.filter')}
        onClosed={() => setOpen(false)}
        from="left"
        zIndex={60}
        components={{ Footer: FilterMenuFooter }}
      >
        <FilterMenu />
      </SideMenu>
    </>
  );
};

export default MobileFilterMenu;
